export default __webpack_public_path__ + "static/lb-05-707441273d42987f07823a5464cac734.webp";